import getStore from 'mini-calendar-store/lib/store/store';
import { getEventToCalendarAssociation } from 'mini-event-to-calendar-association/lib/utils/getEventToCalendarAssociation';
import { globalUpdateFolderIdMapping } from '../utils/globalUpdateFolderIdMapping';
import { mutatorAction } from 'satcheljs';

/**
 * Mutator to update folderIdMapping
 */
export const updateFolderIdMapping = mutatorAction(
    'updateFolderIdMapping',
    (oldKey: string, newKey: string) => {
        const { folderIdMapping } = getStore();
        const { folderIdToCalendarIdMapping } = getEventToCalendarAssociation();
        globalUpdateFolderIdMapping(folderIdMapping, oldKey, newKey);
        globalUpdateFolderIdMapping(folderIdToCalendarIdMapping, oldKey, newKey);
    }
);
